export const ONE_KB = 1000;
export const ONE_HUNDRED_KB = ONE_KB * 100;

export const ONE_MB = ONE_KB * 1000;

export const FORTY_MB = ONE_MB * 40;
